import { Route } from 'react-router-dom';
import ViewCalendar from './containers/ViewCalendar';

export default [
    <Route key="calendar" exact path="/calendar" component={ViewCalendar} />
]
